<app-header></app-header>
<div class="main container py-3 d-flex flex-column mb-5">
  <router-outlet></router-outlet>
</div>
<app-footer></app-footer>
